import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { WhatsAppFloat } from '@/components/WhatsAppFloat';

// Public pages
import HomePage from '@/pages/HomePage';
import PropertiesPage from '@/pages/PropertiesPage';
import PropertyDetailPage from '@/pages/PropertyDetailPage';
import ServicesPage from '@/pages/ServicesPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';

// Admin pages
import AdminLoginPage, { AuthCallback } from '@/pages/admin/AdminLoginPage';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminPropertiesPage from '@/pages/admin/AdminPropertiesPage';
import PropertyFormPage from '@/pages/admin/PropertyFormPage';

function AppRouter() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin-portal');
  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';
  const isPropertiesPage = location.pathname === '/properties';

  // Check for session_id in URL fragment BEFORE rendering routes
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      {!isAdminRoute && !isHomePage && !isAboutPage && !isPropertiesPage && <Navbar />}
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/properties" element={<PropertiesPage />} />
        <Route path="/properties/:id" element={<PropertyDetailPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />

        {/* Admin Routes - Separate URL not shown in public nav */}
        <Route path="/admin-portal" element={<AdminLoginPage />} />
        <Route path="/admin-portal/login" element={<AdminLoginPage />} />
        <Route
          path="/admin-portal/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-portal/properties"
          element={
            <ProtectedRoute>
              <AdminPropertiesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-portal/properties/new"
          element={
            <ProtectedRoute>
              <PropertyFormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-portal/properties/edit/:id"
          element={
            <ProtectedRoute>
              <PropertyFormPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <WhatsAppFloat />}
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;